import { render, staticRenderFns } from "./PersonalBalanceIncomeAssetsCN.vue?vue&type=template&id=0f579b02"
import script from "./PersonalBalanceIncomeAssetsCN.vue?vue&type=script&lang=js"
export * from "./PersonalBalanceIncomeAssetsCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports